import React, {Component} from 'react';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import axios from 'axios';
import auth0Client from '../Auth';
import {SERVER_URL}  from '../Constants';
import {ToastContainer, ToastStore} from 'react-toasts';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Modal from 'react-responsive-modal';
import filterFactory, { textFilter, numberFilter } from "react-bootstrap-table2-filter";

var QRCode = require('qrcode.react');

const paginationOption = {
    custom: true,
    sizePerPage: 100
  };
  const defaultSorted = [{
    dataField: 'requestedDate',
    order: 'asc'
  }];
  const { SearchBar } = Search;
 


function idCountFormatter(cell, row) {
    if (cell === undefined) {return 0;}
    return cell.length;
   
  }
function noteFormatter(cell, row) {
    if (cell === undefined) {return '';}
    return (cell.length > 30)? cell.substring(0,30) + '...': cell;
   
  }


class ParcelPaymentManager extends Component {
    constructor(props){
        super(props);

        this.state = {

            parcelPayments: [],
            filteredItems: [],
            total: 0,
            count: 0,
            paymentDate: new Date(),
            paymentItem:{},
            refreshButtonText: 'Refresh',
            displayDetailPanel: false,
            guestEmail:'',
            phone:'',
            useColumnFilters: true,
        }
        this.tableRef = React.createRef();
        this.rowEvents = {
            onClick: (e, row, rowIndex) => {
             
              this.setState({
                    paymentItem: row,
                    displayDetailPanel: true
                })
             
            
             
             
            },
            
        };
      
        axios.interceptors.response.use(response => {
            return response;
          }, error => {
           if (error.response.status === 401) {
            ToastStore.error("error unauthorized.  Your session has expired. Please log in again");
            
           }
          
      
           return error;
          });
    }

    componentDidMount(){
       this.loadParcelPayments();
    }
    loadParcelPayments = () => {

       
        this.setState({refreshButtonText: 'Refreshing...'});
        axios.post(SERVER_URL +  '/SR/queryParcelPayments/',
            {
                venueId: auth0Client.getActiveVenuedId(),

            },{  
            headers: { 
              'Authorization': `Bearer ${auth0Client.getIdToken()}`,
              'venueId': auth0Client.getActiveVenuedId() 
            }
          }).then((res)=>{
           
            if (res.status !==200) {
              //place your reentry code
              //console.log("Error" + res.status);
              ToastStore.error("An error occured. Please try again: Not authorized");
              this.setState({
                parcelPayments: [],
                filteredItems: []
            })
             }else{
               
                
                this.setState({
                    parcelPayments:res.data,
                    filteredItems:res.data
                });
           
             }
             this.setState({refreshButtonText: 'Refresh'});
            }).catch((e)=>{ 
                ToastStore.error("An error occured. Please try again: " + e.message);
                this.setState({refreshButtonText: 'Refresh'});
              });
    }

    getColumns = () => {
        return [
          

                { dataField: 'name', sort: true, text: 'Bill To', align: 'left',textAlign: 'left',filter: this.customTextFilter(), filterable:true, style:{cursor: 'pointer'}, headerStyle: {width:'280px', overflow: "hidden", textAlign: 'center'} },
                { dataField: 'statusCd', sort: true, text: 'Status', align: 'center',textAlign: 'center',formatter:this.statusFormatter, filter: this.customTextFilter(), filterable:true,  style:{cursor: 'pointer'}, headerStyle: {width:'130px', overflow: "hidden", textAlign: 'center'} },
                { dataField: 'requestedDate', sort: true, text: 'Requested Date', align: 'center',formatter: LostItemFunctions.formatDate,textAlign: 'center', style:{cursor: 'pointer'}, headerStyle: {width:'180px', overflow: "hidden", textAlign: 'center'} },
                { dataField: 'requestedDate', sort: true, text: 'Age (Days)', align: 'center',formatter: LostItemFunctions.formatAge,textAlign: 'center', style:{cursor: 'pointer'}, headerStyle: {width:'180px', overflow: "hidden", textAlign: 'center'} },
                { dataField: 'stripeUpdatedAt', sort: true, text: 'Pmt. Updated', align: 'center',formatter: LostItemFunctions.formatDateTime,textAlign: 'center', style:{cursor: 'pointer'}, headerStyle: {width:'180px', overflow: "hidden", textAlign: 'center'} },
             
                { dataField: 'srItemIds', sort: true, text: '#Parcels',formatter:idCountFormatter, align: 'right',textAlign: 'left', style:{cursor: 'pointer'}, headerStyle: { width:'100px', overflow: "hidden", textAlign: 'center'} },
             
                { dataField: 'amount', sort: true, text: 'Parcel($)', align: 'right',formatter: LostItemFunctions.formatMoney,textAlign: 'right', style:{cursor: 'pointer'},fontWeight:'bold', headerStyle: {width:'150px', overflow: "hidden", textAlign: 'center'} },
                { dataField: 'totalAmount', sort: true, text: 'Total($)', align: 'right',formatter: LostItemFunctions.formatMoney,textAlign: 'right', style:{cursor: 'pointer'}, headerStyle: {width:'150px', overflow: "hidden", textAlign: 'center'} },
                
                { dataField: '_id', sort: true, text: 'Send Receipt', align: 'center',formatter:this.sendReceiptFormatter, textAlign: 'left', style:{cursor: 'pointer', overflowWrap: "anywhere"}, filterable:false,  headerStyle: {width:'170px',  textAlign: 'center'} },

                { dataField: 'email', sort: true, text: 'email', align: 'left',textAlign: 'left', style:{cursor: 'pointer', overflowWrap: "anywhere"},filter: this.customTextFilter(), filterable:true,  headerStyle: {width:'250px',  textAlign: 'center'} },
                { dataField: 'emailSentAt', sort: true, text: 'Email Sent', align: 'center',formatter: LostItemFunctions.formatDateTime,textAlign: 'center', style:{cursor: 'pointer'}, headerStyle: {width:'180px', overflow: "hidden", textAlign: 'center'} },
             
                { dataField: 'phone', sort: true, text: 'phone', align: 'left',textAlign: 'left', style:{cursor: 'pointer'}, filter: this.customTextFilter(), filterable:true, headerStyle: { overflow: "hidden",width:'250px', textAlign: 'center'} },
                { dataField: 'note', sort: true, text: 'note', align: 'left',formatter:noteFormatter,textAlign: 'left', style:{cursor: 'pointer'},filter: this.customTextFilter(), filterable:true,  headerStyle: {width:'250px', overflow: "hidden", textAlign: 'center'} },
 

        ];
    }

    sendReceiptFormatter=(cell, row)=>{
        if (cell === undefined) {return '';}
        if (row.statusCd === 'paid' || row.statusCd === 'refunded'){
          return (
            <div>
                <button className="btn btn-sm btn-outline-primary" title='Send' onClick={() => {this.sendReceipt(row)}}>Send</button>
            </div>
          );  
         
        }
       
    }
   sendReceipt=(row)=>{
        if (window.confirm('Receipts are sent to the email that was used on checkout, which can be different from the one used to send the original request. Are you sure you want to send this receipt?')){
            axios.post(SERVER_URL +  '/SR/sendReceipt',{
                parcelPaymentId:row._id,
                email:row.email,
                phone:row.phone,
               },
               {
                headers: {
                  'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                  'venueId': auth0Client.getActiveVenuedId() 
                }
              }).then((res)=>{
                if (res.status !== 200) {
                  // alert('An error occured. ' + res.message);
                }else
                {
                   //show success message
                    alert('Receipt sent');
                }
              }).catch((e)=>{
                console.log(e);
                alert('An error occured. ' + e.message);
              });
        }
    }

    
    handleInputChange=(event) =>{
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
      }

      customTextFilter =()=>{
        if (this.state.useColumnFilters){
          return(
            textFilter(
              {
                delay: 600, // default is 500ms
                style: {
                  backgroundColor: 'white'
                },
                className: 'form-control form-control-sm',
                placeholder: '',
               // onClick: e => console.log(e)
              }
            )
          )
        } else{
          return null;
        }   
       
      }
    
      customNumberFilter=()=>{
        if (this.state.useColumnFilters){
        return(
          numberFilter(
            {
              delay: 600, // default is 500ms
              style: {
                backgroundColor: 'white'
              },
              withoutEmptyComparatorOption: true,
              //comparators: [Comparator.EQ, Comparator.GT, Comparator.LT],
              className: 'custom-numberfilter-class',
              comparatorClassName: 'form-control form-control-sm',
              numberClassName: ' form-control-sm',
              placeholder: '',
              //onClick: e => console.log(e)
            }
          )
        )
          }else{
            return null
          }
    
      }

      refund=()=>{
        if (window.confirm('Are you sure you want to refund this payment?')){
            axios.post(SERVER_URL +  '/SR/refundParcelPayment',{
                parcelPaymentId:this.state.paymentItem._id,
               }, 
               {
                headers: { 
                  'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                  'venueId': auth0Client.getActiveVenuedId() 
                }
              }).then((res)=>{
                
                if (res.status !== 200) {
                    //place your reentry code
                    //console.log(res);
                    alert('An error occured. ' + res.message);
                 
                 }else{
                    console.log(res.data);
                   this.setState({
                    disabled:false, 
                    displayDetailPanel: false
                     });
                     alert('Refund request sent');
                    
                   
                 }
            
            
                // reload
             
            
                }).catch((e)=>{ 
                    console.log(e);
                    alert('An error occured. ' + e.message);
                });
        }
      }

    renderPopUp = () => {
        return (
            <Modal open={this.state.displayDetailPanel} onClose={()=>{this.setState({displayDetailPanel:false})}} center>
                <div className="container" style={{width:'600px', height:'600px'}}>
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Parcel Payment Details</h3>
                            <hr />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label>Bill To:</label>
                        </div>
                        <div className="col-md-9">
                            <label>{this.state.paymentItem.name}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label>Status:</label>
                        </div>
                        <div className="col-md-9">
                            <label>{this.state.paymentItem.statusCd}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label>Total Amount($):</label>
                        </div>
                        <div className="col-md-9">
                            <label>{this.state.paymentItem.totalAmount}</label>
                        </div>
                    </div>

                    <br/>
                    <div className='row'>
                        <div className='col-11 text-center'>

                            {(this.state.paymentItem.paymentlinkUrl) &&   <QRCode renderAs="jpg" style={{width:'120px' ,height:'120px'}} value={this.state.paymentItem.paymentlinkUrl} />
                            }
                        </div>
                    </div>
                        <br/>
                    <div className="row">
                        <div className="col-md-3">
                            <label>URL:</label>
                        </div>
                        <div className="col-md-9">
                            <label>{this.state.paymentItem.paymentlinkUrl}</label>
                        </div>
                    </div>
                    <hr/>

                    <div className="row">
                        <div className="col-md-3">
                            <label>Email:</label>
                        </div>
                        <div className="col-md-6">
                        
                            <input
                                        disabled={this.state.disabled}
                                        type="text"
                                        onChange={this.handleInputChange}
                                        name="guestEmail"
                                        className="form-control"
                                        placeholder="enter new email address"
                                        value= {this.state.guestEmail}
                                        />

                        </div>
                        <div className='col-3'>
                            <button  className="btn btn-sm btn-success" title='Send' onClick={() => {this.sendEmail()}}>Send Email</button>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <label>Phone:</label>
                        </div>
                        <div className="col-md-9">
                            <label>Not Available Yet</label>
                            
                        </div>
                    </div>
                    <hr/>
                    <br/>
                    <div className="row">
                       
                       {
                        (this.state.paymentItem.statusCd === 'paid') &&
                        <div className="col-md-4">
                            <button  className="btn btn-sm btn-danger" title='Send' onClick={() => {this.refund()}}>Refund</button>
                        </div>
                       }
                       {
                        (this.state.paymentItem.statusCd === 'pending') && <div className="col-md-4">
                            <button  className="btn btn-sm btn-outline-danger" title='Cancel' onClick={() => {this.cancel()}}>Cancel Request</button>
                           </div>
                       }
                        {
                        (this.state.paymentItem.statusCd === 'refunded') && <div className="col-md-12">
                          
                            <label className='text-danger'>Refunded on: {LostItemFunctions.formatDateTime(this.state.paymentItem.refundedAt)}</label>
                            <br/>
                            <label className='text-danger'>Refund By: {this.state.paymentItem.refundedBy}</label>
                           </div>
                       }
                       
                    </div>
                   

                </div>

            </Modal>
        );
    }

    cancel = () => {
        if (window.confirm('Are you sure you want to cancel this request?')){
            axios.post(SERVER_URL +  '/SR/cancelParcelPayment',{
                parcelPaymentId:this.state.paymentItem._id,
               }, 
               {
                headers: { 
                  'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                  'venueId': auth0Client.getActiveVenuedId() 
                }
              }).then((res)=>{
                
                if (res.status !== 200) {
                    //place your reentry code
                    //console.log(res);
                    alert('An error occured. ' + res.message);
                 
                 }else{
                    console.log(res.data);
                   this.setState({
                    disabled:false, 
                    displayDetailPanel: false
                     });
                     alert('Request cancelled');
                    
                   
                 }
            
            
                // reload
             
            
                }).catch((e)=>{ 
                    console.log(e);
                    alert('An error occured. ' + e.message);
                });
        }
    }   

    sendEmail=()=>{

        if(!this.state.guestEmail || this.state.guestEmail === ''){

            alert('Please provide an email address');
            return;
        };
       
        console.log(this.state.paymentItem);
        axios.post(SERVER_URL +  '/ParcelNotify/sendParcelRequest',{
            parcelPaymentId:this.state.paymentItem._id,
            email:this.state.guestEmail,
           }, 
           {
            headers: { 
              'Authorization': `Bearer ${auth0Client.getIdToken()}`,
              'venueId': auth0Client.getActiveVenuedId() 
            }
          }).then((res)=>{
            
            if (res.status !== 200) {
                //place your reentry code
                //console.log(res);
                alert('An error occured. ' + res.message);
             
             }else{
                console.log(res.data);
               this.setState({
                disabled:false, 
                
                 });
                 alert('Email sent');
                
               
             }
        
        
            // reload
             
        
            }).catch((e)=>{ 
                console.log(e);
                alert('An error occured. ' + e.message);
            });

    }

     statusFormatter=(cell,row)=>{
        if (row.statusCd==='pending'){
          return (<h6 className="text-caution">Pending</h6>);
        }else if (row.statusCd==='cancelled'){
          return (<h6 className="text-danger">Cancelled</h6>);
        }else if (row.statusCd==='paid'){
          return (<h6 className="text-success" >Paid</h6>);
        }else if (row.statusCd==='refunded'){
          return (<h6 className="text-danger" >*Refunded*</h6>);
        }
        else {
          return (<h6 className="text-primary">{cell}</h6>);
        }
      
      
      }


    render() {
        return (
            <div>
                <ToastContainer store={ToastStore}/>
                <ToolkitProvider 
                        bootstrap4
                        keyField='id' 
                        data={ this.state.filteredItems } 
                        columns={ this.getColumns()} 
                        
                        defaultSorted={defaultSorted}
                        search
                        >
                        {
                    props => (
                    <div>
                    
                        <SearchBar { ...props.searchProps } />
                        <div className="text-right"><button className="btn btn-primary btn-sm"  onClick={this.loadParcelPayments} >{this.state.refreshButtonText}</button></div>
                        <hr />
                        <BootstrapTable
                        className="table-sm"
                        filter={ filterFactory() }  
                        striped
                        hover
                        condensed
                        
                        rowEvents={
                            {
                              onClick: (e, row, rowIndex) => {
                                // Ignore the clicke vent for the button
                               if (e.target.tagName !== 'BUTTON'){
                                // cancel the click event from bubbling up to the row
                               
                                this.setState({
                                    paymentItem: row,
                                    guestEmail: row.email,
                                    displayDetailPanel :true,
                                  })
                                }else{
                                  e.stopPropagation();
                                }
                             
                              }
                              
                            }
                          }
                     
                        selectRow={ { 
                            mode: 'checkbox', 
                            clickToSelect: true, 
                            hideSelectColumn: true,
                            onSelect: (row, isSelect, rowIndex, e) => {
                                //console.log(rowIndex)
                                //this.setState({
                                //    paymentItem : row,
                                //    displayDetailPanel :true,
                                //    guestEmail: row.email,
                                //});
                                
                            }} }

                        { ...props.baseProps }
                        pagination={ paginationFactory(paginationOption) }
                        />
        {this.renderPopUp()}
      </div>
    )
  }</ToolkitProvider>
            </div>
        );
    }
}

export default ParcelPaymentManager;

